<template>
    <div data-component="ItemBranchSelector"
         class="item-branch-selector">
        <p v-if="showLabel"
           class="item-branch-selector__label">
            {{ l('SELL.SELECT_ITEM_BRANCH') }}
        </p>
        <BranchSelector :value="currentItemBranch"
                        btn-classes="btn btn-default btn-sm"
                        :in-btn-label="inBtnLabel"
                        @input="changeBranch" />
    </div>
</template>

<script>
import BranchSelector from '@/vue/components/Branches/BranchSelector';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    components: { BranchSelector },

    props: {
        /**
         * Add some text next to the dropdown to show what the dropdown is for?
         */
        showLabel: {
            default: false,
            type: Boolean,
        },

        /**
         * If supplied, a lang key to display inside the branch selector button.
         * This is passed on to the BranchSelector component.
         */
        inBtnLabel: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState(['currentItemBranch']),
    },

    methods: {
        /**
         * @param {Branch} newBranch
         */
        changeBranch(newBranch) {
            let oldBranch = container.userService.currentItemBranch;

            console.log(
                'Changing item branch',
                {
                    oldBranchID: oldBranch ? oldBranch.ID : null,
                    newBranchID: newBranch ? newBranch.ID : null,
                },
            );

            container.userService.changeItemBranch(newBranch);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../../less/variables.less";

.item-branch-selector {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    grid-gap: 10px;
    flex-grow: 0;
    flex-shrink: 0;

    p {
        font-size: 12px;
        margin: 0;
    }

    .btn {
        height: 100%;
    }
}

@media (min-width: @non-mobile-min) {
    .item-branch-selector {
        .dropmenu {
            // Ensure all branches can be selected if the list is too long.
            // Not the prettiest solution, but functional.
            max-height: ~"calc(100dvh - 150px)";
            overflow: auto;
        }

        &__label {
            margin: 0;
        }
    }
}

@media (max-width: @mobile-max) {
    .item-branch-selector {
        color: @dt-navy;
    }
}
</style>
